<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <b-tabs pills>
              <b-tab :title="$t('config.products.productCategory.title')">
                <product-category></product-category>
              </b-tab>
              <b-tab :title="$t('config.products.productSubCategory.title')">
                <product-sub-category></product-sub-category>
              </b-tab>
              <b-tab :title="$t('config.products.productManufacture.title')">
                <product-manufacture></product-manufacture>
              </b-tab>
              <b-tab :title="$t('config.products.productModel.title')">
                <product-model></product-model>
              </b-tab>
              <b-tab v-if="hasPermission('SETTINGS_FITMENT_MARKET_ANALYSIS')" :title="$t('config.products.marketAnalysis.title')">
                <fitment-market-analysis-list></fitment-market-analysis-list>
              </b-tab>
              <b-tab v-if="hasPermission('SETTINGS_MACROECONOMIC_INDICATORS')"  :title="$t('config.products.macroeconomicIndicators.title')">
                <macroeconomic-indicators-list></macroeconomic-indicators-list>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
import bTab from 'bootstrap-vue/es/components/tabs/tab';
import ProductCategory from '@/views/config/product-plus/ProductCategoryList';
import ProductSubCategory from '@/views/config/product-plus/ProductSubCategoryList.vue';
import ProductManufacture from '@/views/config/product-plus/ProductManufactureList.vue';
import ProductModel from '@/views/config/product-plus/ProductModelList.vue';
import FitmentMarketAnalysisList from "@/views/config/market-analysis/FitmentMarketAnalysisList";
import MacroeconomicIndicatorsList from "@/views/config/market-analysis/MacroeconomicIndicatorsList.vue";

export default {
  name: "ProductConfig",
  components: {
    'b-tabs': bTabs,
    'b-tab': bTab,
    ProductCategory,
    ProductSubCategory,
    ProductManufacture,
    ProductModel,
    FitmentMarketAnalysisList,
    MacroeconomicIndicatorsList
  }
}
</script>

<style scoped>

</style>